import { useDataIsSubmitting, useDataValue } from 'Simple/Data.js'

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let connection_id = useDataValue({
    context: 'selected',
    path: 'connection_id',
    viewPath: props.viewPath,
  })

  return isSubmitting || !connection_id
}
